import { useEffect, useState } from 'react'
import { IOrder } from '../../../../../app/entities/Order'
import styles from '../styles.module.css'
import {
  CANCELLED_STATUSES,
  ON_THE_WAY_STATUSES,
  SCHEDULED_STATUSES,
  STARTED_STATUSES,
} from '../../../global/constants/order-status'
import OrderTrackerBullet from '../submodals/order-tracker-bullet/OrderTrackerBullet'
import { getHasPreviousOrderBeenStarted } from '../../api'
import { fetchData } from '../../../global/utils/fetch'

interface DeliveryTrackingBulletsProps {
  order: IOrder | null
}

export default function DeliveryTrackingBullets(
  props: DeliveryTrackingBulletsProps,
) {
  const { order } = props
  const orderObjectId = order?.objectId ?? ''
  const tireRackOrder = order?.tireRackOrders[0] ?? undefined

  const [isPrecedingRouteStarted, setIsPrecedingRouteStarted] = useState(false)

  const [orderInTransit, setOrderInTransit] = useState(false)
  const [outForDelivery, setOutForDelivery] = useState(false)
  const [isDelivered, setIsDelivered] = useState(false)

  useEffect(() => {
    fetchHasPreviousOrderBeenStarted(order?.objectId ?? '')
    const hasOrderShipped = Boolean(tireRackOrder?.shippingShippedOn)
    const isOrderAtWarehouse = Boolean(tireRackOrder?.shippingDeliveredOn)
    setOrderInTransit(
      hasOrderShipped ||
        isOrderAtWarehouse ||
        [...ON_THE_WAY_STATUSES, ...SCHEDULED_STATUSES].includes(
          order?.status ?? '',
        ),
    )
    setOutForDelivery(ON_THE_WAY_STATUSES.includes(order?.status ?? ''))
    setIsDelivered(STARTED_STATUSES.includes(order?.status ?? ''))
  }, [order, tireRackOrder])

  async function fetchHasPreviousOrderBeenStarted(orderObjectId: string) {
    const result = await fetchData<boolean>(
      getHasPreviousOrderBeenStarted(orderObjectId),
    )
    if (result !== undefined) {
      setIsPrecedingRouteStarted(result)
    }
  }

  return (
    <div className={styles.trackingInformationContainer}>
      {CANCELLED_STATUSES.includes(order?.status ?? '') ? (
        <OrderTrackerBullet
          isActive={true}
          message={<div>Delivery Cancelled</div>}
        />
      ) : (
        <>
          <OrderTrackerBullet
            isActive={orderInTransit}
            message={
              <div className={styles.orderShippedMessage}>
                Your order is in transit
              </div>
            }
          />
          <OrderTrackerBullet
            isActive={outForDelivery}
            message={
              <div>
                Your order is{' '}
                {isPrecedingRouteStarted && !outForDelivery
                  ? 'a few stops away'
                  : 'coming soon'}
              </div>
            }
          />
          <OrderTrackerBullet
            isActive={isDelivered}
            message={<div>Delivered</div>}
          />
        </>
      )}
    </div>
  )
}
